module.exports = __webpack_public_path__ + "img/slideset-text_active.91e27866.svg";